import * as tslib_1 from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import html2canvas from 'html2canvas';
import SignaturePad from 'signature_pad';
import config from '@/config';
let agreementModal = class agreementModal extends Vue {
    constructor() {
        super(...arguments);
        this.checked = false;
        //是否划到底部了
        this.showBottom = false;
        this.showSign = false;
        this.signaturePad = null;
        this.needCheck = true;
        this.redirect = null;
    }
    async mounted() {
        this.signImg = null;
        setTimeout(this.cutimage, 200);
    }
    //打开签字页面
    showSignPage() {
        this.showSign = true;
        setTimeout(() => {
            this.canvas = this.$refs['canvas'];
            let ctx = this.canvas.getContext('2d');
            this.signaturePad = new SignaturePad(this.canvas, {
                backgroundColor: '#ffffff',
                penColor: 'rgb(0, 0, 0)',
            });
            this.resizeCanvas();
            let self = this;
            this.signaturePad.addEventListener('beginStroke', () => {
                if (self.needCheck) {
                    self.needCheck = false;
                    ctx.fillStyle = '#ffffff';
                    ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
                }
            }, { once: false });
            this.drawSign();
        }, 200);
    }
    async cutimage() {
        let scrollbox = this.$refs['scroll-box'];
        if (this.signImg) {
            scrollbox.scrollTop = scrollbox.scrollHeight - scrollbox.clientHeight;
            this.$nextTick();
        }
        else {
            if (scrollbox.scrollTop + scrollbox.clientHeight >=
                scrollbox.scrollHeight) {
                this.showBottom = true;
            }
        }
    }
    async clickNext() {
        let imgUrl = '';
        let signbox = this.$refs['contents'];
        await html2canvas(signbox, {
            width: signbox.width,
            height: signbox.scrollHeight,
            allowTaint: false,
            useCORS: true,
        }).then(ctx => {
            imgUrl = ctx.toDataURL();
        });
        this.uploadImg(imgUrl);
    }
    async uploadImg(imgStr) {
        let url = '/api/goods/order/tools/tools/uploadBase64';
        if (this.hideBtn) {
            //为了兼容部分从正常商品链接下单的用户，只展示签名页时需调用此接口
            url = '/api/goods/order/tools/sign/recordMemSign';
        }
        let { data } = await this.$axios.post(url, {
            sign: imgStr,
        });
        //正常ket下单，关闭弹窗
        if (!this.hideBtn) {
            this.hide(data);
        }
    }
    hide(r) {
        this.close(r || false);
    }
    get checkSrc() {
        if (!this.showBottom) {
            return require('./images/icon_dischose.png');
        }
        if (this.checked) {
            return require('./images/icon_choose.png');
        }
        else {
            return require('./images/icon_canchoose.png');
        }
    }
    checkedChange() {
        if (!this.showBottom)
            return;
        this.checked = !this.checked;
    }
    clickSign() {
        if (!this.showBottom)
            return;
        if (!this.checked) {
            return this.$Toast('请勾选协议');
        }
        this.showSignPage();
    }
    scrollbox(event) {
        if (this.showBottom)
            return;
        let el = event.target;
        if (el.scrollTop + el.clientHeight >= el.scrollHeight - 20) {
            this.showBottom = true;
        }
    }
    /////////////////////////////////////////////////////////
    //画标志
    drawSign() {
        let img = new Image();
        let ctx = this.canvas.getContext('2d');
        img.crossOrigin = 'anonymous';
        if (config.env === 'production') {
            img.src = 'https://m.ivydad.com/goods/img/img_sign.8110d331.png';
        }
        else {
            img.src = require('./images/img_sign.png');
        }
        let self = this.canvas;
        this.needCheck = true;
        img.onload = function () {
            ctx.drawImage(img, self.width / 2 - 50, self.height / 2 - 220, 95, 465);
        };
    }
    resizeCanvas() {
        this.canvas.width = this.canvas.offsetWidth;
        this.canvas.height = this.canvas.offsetHeight;
        this.canvas.getContext('2d');
        this.signaturePad.clear();
        let newList = [];
        newList.forEach(eve => {
            eve.points.forEach(v => {
                v.num = v.x;
                v.x = (-v.y + 180) * 2;
                v.y = v.num * 2;
            });
        });
    }
    //返回商品页
    clickReturn() {
        this.showSign = false;
    }
    clearButton() {
        this.signaturePad.clear();
        this.drawSign();
    }
    async saveButton() {
        if (this.signaturePad.isEmpty()) {
            return;
        }
        let imgStr = this.signaturePad.toDataURL('image/png');
        this.rotateBase64Img(imgStr, 270);
    }
    async rotateBase64Img(src, edg, callback = null) {
        let canvas = document.createElement('canvas');
        let ctx = canvas.getContext('2d');
        const quadrant = (edg / 90) % 4;
        const cutCoor = { sx: 0, sy: 0, ex: 0, ey: 0 };
        let image = new Image();
        let self = this;
        image.onload = () => {
            let imgW = image.width;
            let imgH = image.height;
            let size = imgW > imgH ? imgW : imgH;
            canvas.width = size * 2;
            canvas.height = size * 2;
            switch (quadrant) {
                case 0:
                    cutCoor.sx = size;
                    cutCoor.sy = size;
                    cutCoor.ex = size + imgW;
                    cutCoor.ey = size + imgH;
                    break;
                case 1:
                    cutCoor.sx = size - imgH;
                    cutCoor.sy = size;
                    cutCoor.ex = size;
                    cutCoor.ey = size + imgW;
                    break;
                case 2:
                    cutCoor.sx = size - imgW;
                    cutCoor.sy = size - imgH;
                    cutCoor.ex = size;
                    cutCoor.ey = size;
                    break;
                case 3:
                    cutCoor.sx = size;
                    cutCoor.sy = size - imgW;
                    cutCoor.ex = size + imgH;
                    cutCoor.ey = size + imgW;
                    break;
            }
            ctx.translate(size, size);
            ctx.rotate((edg * Math.PI) / 180);
            ctx.drawImage(image, 0, 0);
            var imgData = ctx.getImageData(cutCoor.sx, cutCoor.sy, cutCoor.ex, cutCoor.ey);
            if (quadrant % 2 === 0) {
                canvas.width = imgW;
                canvas.height = imgH;
            }
            else {
                canvas.width = imgH;
                canvas.height = imgW;
            }
            ctx.putImageData(imgData, 0, 0);
            this.signImg = canvas.toDataURL();
            this.showGoOrder();
        };
        image.crossOrigin = 'anonymous';
        image.src = src;
    }
    //展示去下单
    showGoOrder() {
        this.showSign = false;
        let self = this;
        setTimeout(() => {
            let scrollbox = self.$refs['scroll-box'];
            scrollbox.scrollTop = scrollbox.scrollHeight - scrollbox.clientHeight;
            //如果是为了部分用户正常下单后补签名，不展示去下单，直接截图上传协议
            if (self.hideBtn) {
                self.clickNext();
            }
        }, 200);
    }
};
tslib_1.__decorate([
    Prop()
], agreementModal.prototype, "close", void 0);
tslib_1.__decorate([
    Prop({ default: {} })
], agreementModal.prototype, "data", void 0);
tslib_1.__decorate([
    Prop({ default: '' })
], agreementModal.prototype, "signImg", void 0);
tslib_1.__decorate([
    Prop({ default: false })
], agreementModal.prototype, "hideBtn", void 0);
agreementModal = tslib_1.__decorate([
    Component({})
], agreementModal);
export default agreementModal;
